import { memo } from "react";

/*
 * A reusable button component with optional loading and variant styles.
 *
 * Props:
 * - children: ReactNode – the button label or content
 * - type: string – HTML button type ('button', 'submit', 'reset'); defaults to 'button'
 * - onClick: function – optional click handler
 * - disabled: boolean – disables the button if true
 * - isLoading: boolean – shows a loading spinner and disables the button if true
 * - className: string – optional additional Tailwind/utility classes
 * - variant: string – visual style of the button ('solid' | 'outline'); defaults to 'solid'
 */
const Button = ({
	children,
	type = "button",
	onClick,
	disabled = false,
	isLoading = false,
	className = "",
	variant = "solid",
	...rest
}) => {
	const isDisabled = disabled || isLoading;
	const baseStyles = `
    flex items-center justify-center px-4 py-2 rounded-lg text-sm md:text-base
    transition-colors duration-200
    disabled:opacity-50 disabled:cursor-not-allowed
  `;
	const variantStyles =
		variant === "outline"
			? "border border-primary text-primary bg-transparent hover:bg-primary hover:text-white"
			: "bg-primary text-white hover:bg-primary-dark";

	return (
		<button
			type={type}
			onClick={isDisabled ? undefined : onClick}
			disabled={isDisabled}
			className={`${baseStyles} ${variantStyles} ${className}`}
			{...rest}
		>
			{isLoading ? (
				<>
					{/* <Spinner className="mr-2" /> */}
					Loading...
				</>
			) : (
				children
			)}
		</button>
	);
};

export default memo(Button);
